import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { FadeDivider } from '@onesource/components';
import { getBlockUserMutationKey, useGetBlockedUsersQuery } from '@onesource/services';
import { useIsMutating } from '@tanstack/react-query';
import { FC } from 'react';
import { MdBlock } from 'react-icons/md';

import { AccountBlockedUserSearch } from './account-blocked-user-search';
import { AccountBlockedUsersList } from './account-blocked-users-list';
import { AccountBlockedUsersListSkeleton } from './account-blocked-users-list-skeleton';

// ----------------------------------------------------------------------

export const AccountBlockedUsersSection: FC = () => {
  const { data: blockedUsers, isLoading } = useGetBlockedUsersQuery();
  // Covers the block request and the list refetch that follows it.
  const isBlocking = useIsMutating({ mutationKey: getBlockUserMutationKey() }) > 0;

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1, color: 'primary.main' }}>
        <MdBlock size={22} />
        <Typography variant="h6" fontWeight={700}>
          Blocked Users
        </Typography>
      </Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Blocked members can&apos;t see or interact with your content or mention you, and you won&apos;t see their posts,
        comments or reactions. They aren&apos;t notified when you block them.
      </Typography>

      <FadeDivider />

      <Box sx={{ mb: 3 }}>
        <AccountBlockedUserSearch disabled={isBlocking} />
      </Box>

      {isBlocking && <AccountBlockedUsersListSkeleton rows={1} />}
      {isLoading ? (
        <AccountBlockedUsersListSkeleton />
      ) : (
        <AccountBlockedUsersList users={blockedUsers ?? []} hideEmptyState={isBlocking} />
      )}
    </Box>
  );
};
